export function normalizeString(value) {
  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[-_\s]+/g, "")
    .trim()
    .toLowerCase();
}

export function compareStr(currentValue, referenceValue) {
  return normalizeString(currentValue) === (referenceValue);
}
